module.exports = "/images/three-dot-icon.svg?07a884b80d331e48fdbe01f8035f76ce";